import {
  U21Avatar,
  U21MenuList,
  U21MenuListOptionProps,
} from 'app/shared/u21-ui/components';
import { useReassignAlert } from 'app/modules/alerts/queries/useReassignAlert';
import { useMemo, useState } from 'react';
import { getAgentDisplayName } from 'app/modules/agents/utils';
import { AgentStatus } from 'app/modules/agents/models';
import {
  DEFAULT_OFFSET,
  DEFAULT_PAGINATION_LIMIT,
} from 'app/shared/pagination/constants';
import { useAgentSearch } from 'app/modules/agents/queries/useAgentSearch';

interface Props {
  id: number;
  onSuccess?: () => void;
}

export const ReassignMenuList = (props: Props) => {
  const { id, onSuccess } = props;

  const [search, setSearch] = useState('');
  const {
    agents,
    query: { isLoading: agentsLoading },
  } = useAgentSearch({
    limit: DEFAULT_PAGINATION_LIMIT,
    offset: DEFAULT_OFFSET,
    query: [search],
    statuses: [AgentStatus.ACTIVE],
  });

  const { mutateAsync: reassignAlert } = useReassignAlert([id]);

  const options = useMemo<U21MenuListOptionProps[]>(
    () => [
      {
        icon: <U21Avatar name="?" />,
        text: 'Unassigned',
        onClick: async () => {
          try {
            await reassignAlert(-1);
            onSuccess?.();
          } catch {}
        },
      },
      ...agents.map((i) => {
        const name = getAgentDisplayName(i);
        return {
          text: name,
          onClick: async () => {
            try {
              await reassignAlert(i.id);
              onSuccess?.();
            } catch {}
          },
          icon: <U21Avatar name={name} src={i.picture} />,
        };
      }),
    ],
    [agents, onSuccess, reassignAlert],
  );

  return (
    <U21MenuList
      loading={agentsLoading}
      options={options}
      placeholder="Search agents"
      onSearch={setSearch}
    />
  );
};
